import React, { useContext } from 'react'
import { Link } from 'react-router-dom'
import Banner from '../components/Banner'
import Card from '../components/Card'
import { BiSolidRightArrow } from "react-icons/bi";
import { motion } from "framer-motion";
import { MyContext } from '../contexts/MyContext';
import { useTheme } from '../contexts/ThemeContext';

const Home = () => {
    const {projects} = useContext(MyContext)
    const { isDark } = useTheme();

    return (
        <div className='flex-1'>
            {/* Banner */}
            <Banner />

            {/* Projects Section */}
            <div className='flex flex-col items-center justify-center mt-16 md:mt-24'>
                <div className='container'>
                    {/* Section Header */}
                    <div className="flex flex-wrap justify-center">
                        <div className="w-full px-4">
                            <motion.div
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.5 }}
                                viewport={{ once: true }}
                                className="text-center mx-auto lg:mb-12 mb-8 max-w-[510px]"
                            >
                                <h2 className={`font-mono font-bold text-2xl sm:text-3xl md:text-4xl mb-3 ${
                                    isDark ? 'text-dark-text-primary' : 'text-light-text-primary'
                                }`}>
                                    <span className={isDark ? 'text-dark-brand-primary' : 'text-light-brand-primary'}>
                                        $
                                    </span>
                                    {' '}ls{' '}
                                    <span className={isDark ? 'text-dark-brand-secondary' : 'text-light-brand-secondary'}>
                                        ./recent_projects
                                    </span>
                                </h2>
                                <p className={`text-sm md:text-base font-mono ${
                                    isDark ? 'text-dark-text-secondary' : 'text-light-text-secondary'
                                }`}>
                                    <span className={isDark ? 'text-dark-brand-accent' : 'text-light-brand-accent'}>
                                        //
                                    </span>
                                    {' '}Latest work and projects
                                </p>
                            </motion.div>
                        </div>
                    </div>

                    {/* Project Cards Grid */}
                    <div className='flex flex-wrap justify-center gap-6 lg:gap-8'>
                        {projects?.slice(0,3)?.map((item, index) => {
                            return (
                                <Card item={item} index={index} key={index} selectedTab={"All"}/>
                            )
                        })}
                    </div>
                </div>

                {/* See More Button */}
                <Link to="/projects">
                    <motion.button
                        onClick={() => window.scrollTo(0,0)}
                        whileHover={{ scale: 1.05, x: 5 }}
                        whileTap={{ scale: 0.95 }}
                        className={`flex items-center gap-2 font-mono text-sm md:text-base font-medium my-12 px-6 py-3 rounded-lg border transition-all ${
                            isDark
                                ? 'text-dark-brand-primary border-dark-brand-primary hover:bg-dark-brand-primary hover:text-dark-bg-primary'
                                : 'text-light-brand-primary border-light-brand-primary hover:bg-light-brand-primary hover:text-white'
                        }`}
                    >
                        $ view_all_projects
                        <BiSolidRightArrow className="text-xs"/>
                    </motion.button>
                </Link>
            </div>
      </div>
    )
}

export default Home
